// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from "./router"
import store from './store'
import Axios from "axios"
import '@/permission' // permission control

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// 视频播放插件
// import VideoPlayer from 'vue-video-player'
// import 'video.js/dist/video-js.css'
// Vue.use(VideoPlayer)

// 图片预览插件
// import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
// import 'vue-directive-image-previewer/dist/assets/style.css'
// Vue.use(VueDirectiveImagePreviewer)

Vue.config.productionTip = false
Vue.prototype.$axios = Axios

// Vue.prototype.HOST = '/test' // Container.vue logout使用
// Vue.prototype.MAP_KEY = '64IBZ-UFW3W-UM6RU-R5YBT-TXI3Q-3QBZJ'

const app = new Vue({
  el: '#app',
  render: h => h(App),
  store,
  router
})
export default app



// WEBPACK FOOTER //
// ./src/main.js